var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44 24.0096C44 35.0275 35.0232 44 24 44C12.9768 44 4 35.0275 4 24.0096C4 12.9725 12.9768 4 24 4C35.0232 4 44 12.9725 44 24.0096Z",
    fill: "#FACD66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24.0097C32 24.5152 31.8409 25.0226 31.5227 25.4289C31.4631 25.5086 31.1847 25.8372 30.9659 26.051L30.8466 26.1677C29.1761 27.9388 25.0199 30.6022 22.9119 31.4557C22.9119 31.4751 21.6591 31.9825 21.0625 32H20.983C20.0682 32 19.2131 31.4965 18.7756 30.68C18.5369 30.2309 18.3182 28.9283 18.2983 28.9108C18.1193 27.7424 18 25.9538 18 23.9903C18 21.9315 18.1193 20.0632 18.3381 18.9162C18.3381 18.8967 18.5568 17.8469 18.696 17.497C18.9148 16.9934 19.3125 16.5638 19.8097 16.2916C20.2074 16.0991 20.625 16 21.0625 16C21.5199 16.0214 22.375 16.3111 22.7131 16.4471C24.9403 17.3026 29.196 20.1021 30.8267 21.8129C31.1051 22.0851 31.4034 22.4175 31.483 22.4933C31.821 22.921 32 23.4459 32 24.0097Z",
    fill: "#FACD66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.f932809e0635184bc02398f5158746a1.svg";
export { ForwardRef as ReactComponent };